import { fetchPatientById } from '@/layers/presentation/services/patients';
import logger from '@/layers/support/monitoring/logger';
import { PatientExtended } from '@/types/models';
import { useEffect, useState } from 'react';

const LOG_MODULE = 'FE [Presentation / Hooks / Patient]';

export function usePatient(patientId: string | undefined) {
  const [patient, setPatient] = useState<PatientExtended | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  logger.debug(`${LOG_MODULE} usePatient`, {
    patientId,
    patient,
    isLoading,
    error,
  });

  useEffect(() => {
    const fetchData = async () => {
      if (!patientId) {
        setIsLoading(false);
        return;
      }

      try {
        const fetchedPatient = await fetchPatientById(patientId);
        setPatient(fetchedPatient);
      } catch (error) {
        setError((error as Error).message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [patientId]);

  return { patient, isLoading, error };
}
